export const MEMO_BYTE_LIMIT = import.meta.env.VITE_MEMO_BYTE_LIMIT
  ? parseInt(import.meta.env.VITE_MEMO_BYTE_LIMIT)
  : 500 * 1024; // 500 KB
